import React from "react";
import ProgressBar from "components/ProgressBar";
import * as utils from "common/utils";

const SummaryRow = ({ baseValue, actualValue, label, category, prefix = category, subcategory, unit, footnote, totalBase, totalActual, rowClass, changeOverride, indent, id = `${utils.strToId(prefix, "")}_${utils.strToId(label, "")}`, showZero }) => {
    const diff = actualValue - baseValue || 0;
    const increased = diff > 0;
    const decreased = diff < 0;
    const diffPercentage = baseValue !== 0 && baseValue !== "0" ? (100 * diff) / parseFloat(baseValue) : 100;
    const diffPerFormatted = baseValue === 0 && actualValue > 0 ? "+100%" : diffPercentage > 0 ? `+${utils.round(diffPercentage, 1)}%` : `${utils.round(diffPercentage, 1)}%`;
    const change = increased ? `+${diff.toLocaleString()}` : decreased ? diff.toLocaleString() : "-";
    const changeTextClassName = decreased ? "u-textError u-textBold" : "u-textSuccess u-textBold";
    const changeArrowClassName = increased ? "icon-arrow-up1 IconLink--compressed" : decreased ? "icon-arrow-down1 IconLink--compressed" : "";
    const progressActual = totalActual > 0 ? utils.round((actualValue / totalActual) * 100, 1) : 0;
    const progressBase = totalBase > 0 ? utils.round((baseValue / totalBase) * 100, 1) : 0;
    if (!showZero && actualValue === 0 && (!baseValue || baseValue === 0)) return null;

    return (
        <tr className={rowClass}>
            {category && <td className="u-font-600 u-pl-md">{category}</td>}
            {subcategory && <td>{subcategory}</td>}
            <td className={indent ? "u-pl-lg" : "u-pl-sm"}>
                {`${label} ${unit ? "(" + unit + ")" : ""}`} {footnote && <sup>{footnote}</sup>}
            </td>
            {baseValue !== undefined && (
                <td className="u-before u-textRight">
                    <div className="u-mb-sm u-textBold u-pt-sm u-pr-md" id={`base_${id}`}>
                        {(baseValue || "-").toLocaleString()}
                    </div>
                    {progressBase > 0 && <ProgressBar colour="#cae1f3" endLabel={`${progressBase}%`} progress={progressBase} showZero={false} />}
                </td>
            )}
            <td className={baseValue !== undefined ? "u-after" : ""}>
                <div className="u-textRight u-mb-sm u-textBold u-pt-sm u-pr-md" id={`actual_${id}`}>
                    {(actualValue || "-").toLocaleString()}
                </div>
                {progressActual > 0 && <ProgressBar colour="#caf3d6" endLabel={`${progressActual}%`} progress={progressActual} showZero={false} />}
            </td>

            {baseValue !== undefined && (
                <td>
                    {diff !== 0 && !changeOverride ? (
                        <div className="u-flex u-flexJustifyEnd u-flexAlignItemsCenter">
                            <div className="u-text-sm">({diffPerFormatted})</div>
                            <div className="u-flex u-flexJustifyBetween u-flexAlignItemsCenter u-textBold u-textSecondary u-ml-xs">
                                <span id={`change_${id}`}>{change.toLocaleString()}</span>
                                <span className={`${changeArrowClassName} ${changeTextClassName}`}></span>
                            </div>
                        </div>
                    ) : (
                        <div className="u-textRight">{changeOverride ? `${changeOverride}` : "-"}</div>
                    )}
                </td>
            )}
        </tr>
    );
};

export default SummaryRow;
